export enum AccountProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  PASSWORD = 'password',
}

export enum AccountType {
  OAUTH = 'oauth',
  OIDC = 'oidc',
  CREDENTIALS = 'credentials',
}

export interface LinkedAccount {
  provider: AccountProvider;
  providerAccountId: string;
}

export const SOCIAL_PROVIDERS = [AccountProvider.GOOGLE, AccountProvider.FACEBOOK] as const;
